import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class SEp2 extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="page container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Special Episode 2: Happy Pride Month!</h1>
                        <h5 className="korean-title">특별 에피소드 2: 한국의 프라이드/퀴어문화축제</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

                LGBTQ issues remain a sensitive topic in Korea today. One's sexual identity and orientation aren't topics that are readily or openly discussed.
                And while many are open and accepting of the LGBTQ community, there are indeed people that are not.
                However, I believe our country is making progress and becoming more accepting in recent years.
                I hope that this trend will continue, and happy pride, everybody!
                
                <br></br>
                Click <a target="_blank" href="https://nonbinary.wiki/wiki/Glossary_of_Korean_gender_and_sex_terminology">here</a> to visit a website with vocabulary related to the LGTBQ community.
                <br></br>
                Click <a target="_blank" href="https://i-d.vice.com/en_us/article/a3vgj5/7-creatives-on-the-queer-scene-in-seoul">here</a> to read interesting stories about being queer in Seoul.
                <br></br>
                Click <a target="_blank" href="https://www.lgbtqnation.com/2019/06/pride-without-pictures-south-korea-strict-laws-taking-photos-pride/">here</a> to read more about governmental/societal discrimination in Korea towards the LGBTQ community.


                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <SEp2></SEp2>
        </div>
    );
}


  const Sepisode2 = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Sepisode2;